<div class="dialogContainer">

    <!--------------------------------------------------------------  Usuario -->

    <h6 class="ft500 ft16">Detalle de transacción</h6>
    <hr>


    <div class="mgt10 ">
        <span class="ft14 ft500 gray-8">Usuario: </span>
    </div>
    <div>
        <div>
            <span class="title">Id: </span>
            <span>{{array.usuarioId}}</span>
        </div>

        <div>
            <span class="title">Email: </span>
            <span>{{array.usuarioNombre}}</span>
        </div>

        <div>
            <span class="title">Nombre: </span>
            <span>{{array.usuarioEmail}}</span>
        </div>

        <div>
            <span class="title">Tipo: </span>
            <span>{{array.usuarioTipo}}</span>
        </div>
    </div>


    <!-------------------------------------------------------------- Curso-->

    <div class="mgt10 ">
        <span class="ft14 ft500 gray-8">Curso: </span>
    </div>
    <div>

        <div>
            <span class="title">Id: </span>
            <span>{{array.cursoId}}</span>
        </div>

        <div>
            <span class="title">Título: </span>
            <span>{{array.cursoTitulo}}</span>
        </div>

        <div>
            <span class="title">Precio Original: </span>
            <span>{{array.cursoPrecioOriginal}}</span>
        </div>

        <div>
            <span class="title">Descuento: </span>
            <span>{{array.cursoPorcentajeDescuento}}%</span>
        </div>

        <div>
            <span class="title">Precio Final: </span>
            <span>{{array.cursoPrecioFinal}}</span>
        </div>
    </div>



    <!-------------------------------------------------------------- Transaccion -->
    <div class="mgt10 ">
        <span class="ft14 ft500 gray-8">Transacción: </span>
    </div>

    <div>
        <div>
            <span class="title">Moneda: </span>
            <span>{{array.transaccionMoneda}}</span>
        </div>

        <div>
            <span class="title">Tax: </span>
            <span>{{array.transaccionTax}}</span>
        </div>

        <div>
            <span class="title">Comision: </span>
            <span>{{array.transaccionComisionCobro}}</span>
        </div>

        <div>
            <span class="title">Fecha: </span>
            <span *ngIf="array.transaccionFecha">{{array.transaccionFecha.toDate() | date}}</span>
        </div>

        <div>
            <span class="title">Estatus Cobro: </span>
            <span>{{array.transaccionEstatusCobro}}</span>
        </div>

        <div>
            <span class="title">Via cobro: </span>
            <span>{{array.transaccionViaCobro}}</span>
        </div>

        <div>
            <span class="title">Transaccion Id: </span>
            <span>{{array.transaccionId}}</span>
        </div>
    </div>

    <!------------------------------------------------------------- instructor -->

    <div class="mgt10 ">
        <span class="ft14 ft500 gray-8">Instructor: </span>
    </div>
    <div>
        <div>
            <span class="title">Id: </span>
            <span>{{array.instructorId}}</span>
        </div>

        <div>
            <span class="title">Nombre: </span>
            <span>{{array.instructorNombre}}</span>
        </div>

        <div>
            <span class="title">Porcentaje: </span>
            <span>{{array.instructorPorcentaje}}</span>
        </div>

        <div>
            <span class="title">Total: </span>
            <span>{{array.instructorTotal}}</span>
        </div>

        <div>
            <span class="title">Estatus Pago: </span>
            <span>{{array.instructorEstatusPago}}</span>
        </div>

        <div>
            <span class="title">Fecha Pago: </span>
            <span *ngIf="array.instructorFechaPago">{{array.instructorFechaPago.toDate() | date}}</span>
        </div>

        <div>
            <span class="title">Via Pago: </span>
            <span>{{array.instructorViaPago}}</span>
        </div>

        <div>
            <span class="title">Pago Id: </span>
            <span>{{array.pagoId}}</span>
        </div>
    </div>

    <!------------------------------------------------------------- Modificar venta -->
    <div class="pdt20 border-t mgt20">
        <h6 class="ft500 ft14">Modificar transacción</h6>
        <div class="mgt10 mgb10">
            <label class="ft12">Estatus de cobro</label>
            <select [(ngModel)]="array.transaccionEstatusCobro" [ngModelOptions]="{standalone: true}" class="fw ft11">
                <option [ngValue]="'paid'">paid</option>
                <option [ngValue]="'unpaid'">unpaid</option>
                <option [ngValue]="'refunded'">refunded</option>
                <option [ngValue]="'canceled'">canceled</option>
            </select>
        </div>
    
        <p class="ft12 default-font-color">Deja un comentario acerca del motivo de cancelación</p>
        <textarea type="text" [(ngModel)]="array.transaccionComentario" class="fw ft11"></textarea>
        <button (click)="modificarTransaccion()" class="mgt10 darkButton ft11">Modificar Transaccion</button>
    </div>


</div>